import moment from 'jalali-moment';

export const calculateDate = (day: string) => {
  const jalaliDate = moment(day);
  jalaliDate.locale('fa');
  return jalaliDate.format('DD MMMM YYYY ');
};
